import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mzic-divider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mzic-divider.component.html',
  styleUrls: ['./mzic-divider.component.scss'],
})
export class MzicDividerComponent {

  @Input() variant!: string
}
